module.exports = __webpack_public_path__ + "static/img/WendlerWorkoutAccessory_iphone.5add55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WendlerWorkoutAccessory_iphone.png
// module id = MHeU
// module chunks = 1